import { Form, Formik } from 'formik'

import { ChangePasswordForm } from './change-password-form.component'
import { useChangeUserPassword } from 'src/hooks'
import { IChangeUserPasswordFormProps } from 'src/types'

import { changePasswordSchema } from 'src/common/validations'

interface IChangePasswordFormWrapperProps {
  handleVerificationFormChange: () => void
}

const ChangePasswordFormWrapper = ({
  handleVerificationFormChange,
}: IChangePasswordFormWrapperProps) => {
  const { mutateAsync: changePassword } = useChangeUserPassword()

  const handlePasswordChangeSubmit = async ({
    newPassword,
    oldPassword,
  }: IChangeUserPasswordFormProps) => {
    await changePassword({ newPassword, oldPassword })
    handleVerificationFormChange()
  }

  return (
    <Formik
      initialValues={{ newPassword: '', newPasswordConfirm: '', oldPassword: '' }}
      onSubmit={handlePasswordChangeSubmit}
      validationSchema={changePasswordSchema}
    >
      <Form>
        <ChangePasswordForm />
      </Form>
    </Formik>
  )
}

export { ChangePasswordFormWrapper }
